// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see TaxEfileUpgradeStartEvent
 */
export var TaxEfileUpgradeStart = function (_a) {
    var destination = _a.destination, entryPoint = _a.entryPoint, flowToken = _a.flowToken, hasUpgraded = _a.hasUpgraded, isFromDesktop = _a.isFromDesktop, scenarioInitiatorType = _a.scenarioInitiatorType, startedAt = _a.startedAt, userAgent = _a.userAgent;
    return ({
        name: "TaxEfile Upgrade Start",
        parameters: {
            cdf_entity: "TaxEfile",
            cdf_action: "Upgrade",
            destination: destination !== undefined && destination !== null ? destination.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_upgraded: hasUpgraded !== undefined && hasUpgraded !== null ? hasUpgraded.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_from_desktop: isFromDesktop !== undefined && isFromDesktop !== null ? isFromDesktop.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            scenario_initiator_type: scenarioInitiatorType !== undefined && scenarioInitiatorType !== null ? scenarioInitiatorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            started_at: startedAt !== undefined && startedAt !== null ? startedAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            user_agent: userAgent !== undefined && userAgent !== null ? userAgent.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxEfileUpgradeCompleteEvent
 */
export var TaxEfileUpgradeComplete = function (_a) {
    var completedAt = _a.completedAt, flowToken = _a.flowToken;
    return ({
        name: "TaxEfile Upgrade Complete",
        parameters: {
            cdf_entity: "TaxEfile",
            cdf_action: "Upgrade",
            completed_at: completedAt !== undefined && completedAt !== null ? completedAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxEfileFileStartEvent
 */
export var TaxEfileFileStart = function () { return ({
    name: "TaxEfile File Start",
    parameters: {
        cdf_entity: "TaxEfile",
        cdf_action: "File",
    }
}); };
/**
 * @see TaxEfileFileReviewEvent
 */
export var TaxEfileFileReview = function (_a) {
    var gettingRefund = _a.gettingRefund, refund = _a.refund;
    return ({
        name: "TaxEfile File Review",
        parameters: {
            cdf_entity: "TaxEfile",
            cdf_action: "File",
            getting_refund: gettingRefund !== undefined && gettingRefund !== null ? gettingRefund.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            refund: refund !== undefined && refund !== null ? refund.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxEfileFileSubmitEvent
 */
export var TaxEfileFileSubmit = function (_a) {
    var gettingRefund = _a.gettingRefund, refund = _a.refund;
    return ({
        name: "TaxEfile File Submit",
        parameters: {
            cdf_entity: "TaxEfile",
            cdf_action: "File",
            getting_refund: gettingRefund !== undefined && gettingRefund !== null ? gettingRefund.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            refund: refund !== undefined && refund !== null ? refund.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxEfileFileFedAcceptEvent
 */
export var TaxEfileFileFedAccept = function (_a) {
    var gettingRefund = _a.gettingRefund, refund = _a.refund, cashDepositer = _a.cashDepositer, incentive = _a.incentive;
    return ({
        name: "TaxEfile File FedAccept",
        parameters: {
            cdf_entity: "TaxEfile",
            cdf_action: "File",
            getting_refund: gettingRefund !== undefined && gettingRefund !== null ? gettingRefund.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            refund: refund !== undefined && refund !== null ? refund.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cash_depositer: cashDepositer !== undefined && cashDepositer !== null ? cashDepositer.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            incentive: incentive !== undefined && incentive !== null ? incentive.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
